<template>
    <Transition name="fade" mode="out-in">
        <div>
            <slot />
            <ModalsContainer />
        </div>
    </Transition>
</template>

<script setup lang="ts">
import type { FlashMessages } from '../types';
import { useWatchMessages } from '../composables/messages';
import {
    // @ts-ignore
    ModalsContainer,
} from 'vue-final-modal';

const props = defineProps<{ flash?: FlashMessages; }>();

useWatchMessages(() => props?.flash);
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition-duration: 0.2s;
    transition-property: opacity;
    transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
    opacity: 0
}
</style>
